import { BadgeId, BadgesStats } from '../Models';
import { WritingBadge } from './WritingBadge';
import moment from 'moment';

export default class SubmarineBadge extends WritingBadge {
  public readonly id = BadgeId.submarine;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const hour = moment(stats.todaysPage.startedWritingAt)
      .toDate()
      .getHours();
    return hour > 23 || hour < 4;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/submarine.ts